import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { ASAP } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'gift-send-message-selector',
  templateUrl: './gift-send-message-selector.component.html',
  styleUrls: ['./gift-send-message-selector.component.scss']
})
export class GiftSendMessageSelectorComponent implements OnInit {
  @Input() sendingOption = ASAP;
  @Output() onDataChanged = new EventEmitter<string>();

  public ASAP = ASAP;

  constructor() {
  }

  ngOnInit() {
  }

}
